import Vue from 'vue';

const KEY = 'expert.presentation.v1';
function savedMode() {
  try { return localStorage.getItem(KEY) === 'renewed'; } catch (_) { return false; }
}
export const presentation = Vue.observable({ renewed: savedMode() });
export function setPresentation(renewed) {
  presentation.renewed = renewed;
  try { localStorage.setItem(KEY, renewed ? 'renewed' : 'legacy'); } catch (_) { /* The switch still works without storage. */ }
}
